import React, { Component } from 'react'; 
import { withStyles, Typography, Divider, Paper, Button, Grid } from '../../../node_modules/@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { } from '@material-ui/core';
import db from '../../config/firestoreConfig';


const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        margin: 'auto',
        width: '75%',
      },
      container: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 20,
        width: '75%',
        margin: 'auto'
      },
      paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: 'auto',
        overflowX: 'auto'
    },
      button: {
        margin: theme.spacing.unit,
        width: 150,
        height: 75
      },
      button2: {
        margin: theme.spacing.unit,
      },
})


 
class Abilities extends Component {
    constructor (props) {
        super(props)
        this.state = {
            abilities: [],
            content: [],
            loaded: false,
            loading: true
        }
    }


    componentDidMount ()  {
        db.collection('Level').doc(this.props.match.params.ref).collection('Subjects').doc(this.props.match.params.subject).collection('Years').doc(this.props.match.params.year).collection('Abilities').get()
            .then(snapshot => {
                snapshot.forEach( ability => {
                    this.setState({
                        abilities: this.state.abilities.concat(ability.id),
                    })
                })
                console.log('done')
                this.setState({
                    loaded: true
                })
            })
            console.log('waiting')
    }
    
    viewAbility = (ability) => { 
        let url = this.props.match.url;
        url = url + '/' + ability;
        // console.log(subject) //quick debug line
        window.location.replace(url)
    }

    render(){
        const { classes } = this.props;
        return (
        <div className={classes.root}>
            <Paper className={classes.paper} elevation={1}>
                <Typography variant='headline'>
                    Ability Groups For
                </Typography>
                <Button className={classes.button2} variant='outlined' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref)}}>
                    {this.props.match.params.ref}
                </Button>
                    - 
                <Button className={classes.button2} variant='outlined' onClick={() => {window.location.replace('/' + this.props.match.params.id + '/levels/' + this.props.match.params.ref + '/' + this.props.match.params.subject)}}>
                    {this.props.match.params.subject}
                </Button>
                    - 
                <Button className={classes.button2} variant='outlined' color='secondary'>
                    {'Year ' + this.props.match.params.year}
                </Button>
                <br/>
                <Divider/>
                {(this.state.loaded) && (this.state.abilities.length > 0) ?
                
                    
                    
                        <Grid container
                                spacing={24}
                                direction='row'
                                justify='space-evenly'
                                alignContent='center'
                            >
                        <div className={classes.container}>
                            {this.state.abilities.map(ability => {
                                const index = this.state.abilities.indexOf(ability)
                                return(
                                    <Grid item xs={4}>
                                        <div style={{display: 'inline-block'}}>
                                            <Button variant='outlined' className={classes.button} value={ability}
                                                onClick={() => this.viewAbility(ability)}>
                                                    <Typography variant='subheading' style={{width: '100%'}}>
                                                        {ability}
                                                    </Typography>
                                            </Button>
                                        </div>
                                    </Grid>
                                )
                            })}
                        </div> 
                        </Grid>
                
                : 
                <Grid container
                    spacing={24}
                    direction='row'
                    justify='space-evenly'
                    alignContent='center'
                >
                    <br/>
                    {this.state.loading ? 
                        <Grid item xs={3}>
                                <div style={{width: '100%', alignItems: 'center'}}>
                                    <CircularProgress className={classes.progress} color="inherit" />
                                </div> 
                                {setTimeout(() => {this.setState({loading: false})}, 2000)}
                        </Grid>  
                    :
                        <Grid item xs={6}>
                            <Typography variant='subheading' style={{marginTop: 20}}>
                                You have no ability groups in this year group
                            </Typography>
                        </Grid> 
                    }
                </Grid>
                }
            </Paper>
        </div>
    
        )
    }
        
}
export default withStyles(styles)(Abilities)


// WEBPACK FOOTER //
// ./src/pages/View/abilities.jsx